import { useState } from 'react';
import { Helmet } from 'react-helmet-async';
import { WelcomeNav } from '@/components/welcome/WelcomeNav';
import { WelcomeHero } from '@/components/welcome/WelcomeHero';
import { PainPoints } from '@/components/welcome/PainPoints';
import { ComparisonToggle } from '@/components/welcome/ComparisonToggle';
import { Testimonials } from '@/components/welcome/Testimonials';
import { Assessment } from '@/components/welcome/Assessment';
import { ServicesGrid } from '@/components/welcome/ServicesGrid';
import { LeadCaptureForm } from '@/components/welcome/LeadCaptureForm';
import { ClosingSection } from '@/components/welcome/ClosingSection';
import { WelcomeFooter } from '@/components/welcome/WelcomeFooter';
import { TaxChecklist } from '@/components/welcome/TaxChecklist';
import { WelcomeErrorBoundary } from '@/components/welcome/WelcomeErrorBoundary';

const Welcome = () => {
  const [checklistOpen, setChecklistOpen] = useState(false);

  return (
    <WelcomeErrorBoundary>
      <div className="min-h-screen">
        <Helmet>
          <title>Welcome to KGOB CPAs & Advisors | Never Pay More Than You Have To</title>
          <meta name="description" content="KGOB helps businesses and individuals across the United States keep more of what they earn through proactive tax strategy, not just annual filing. Schedule your free strategy session." />
          <link rel="canonical" href="https://kgob.com/welcome" />
        <meta property="og:title" content="Welcome to KGOB CPAs & Advisors | Never Pay More Than You Have To" />
        <meta property="og:description" content="KGOB helps businesses and individuals across the United States keep more of what they earn through proactive tax strategy, not just annual filing." />
        <meta property="og:url" content="https://kgob.com/welcome" />
        <meta property="og:type" content="website" />
      </Helmet>

        <WelcomeNav />

        <main>
          <WelcomeHero />
          <PainPoints />
          <ComparisonToggle />
          <Testimonials />
          <Assessment onOpenChecklist={() => setChecklistOpen(true)} />
          <ServicesGrid />
          <LeadCaptureForm />
          <ClosingSection />
        </main>

        <WelcomeFooter />

        <TaxChecklist
          isOpen={checklistOpen}
          onClose={() => setChecklistOpen(false)}
        />
      </div>
    </WelcomeErrorBoundary>
  );
};

export default Welcome;
